<template>
    <div class="customfields-history">
        <CompassButton
            v-if="enabled"
            :label="$t.__('CustomfieldsHistory.button.label')"
            type="secondary"
            size="small"
            leftIcon="history"
            @click.stop="openHistory"
        />
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Feature from 'Services/Feature';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    props: {
        cfid: {
            type: Number,
            required: true,
        },
        cfname: {
            type: String,
            required: true,
        },
        linkedtype: {
            type: String,
            default: null,
        },
        linkedid: {
            type: Number,
            default: null,
        },
        emitEditSuccess: {
            type: String,
            default: null,
        },
    },
    computed: {
        enabled() {
            return Feature.isEnabled('custom-field-history-panel');
        },
    },
    methods: {
        ...popupPanelMapActions(['open']),
        openHistory() {
            this.open({
                key: 'customfieldHistoryPanel',
                props: {
                    cfname: this.cfname,
                    cfid: this.cfid,
                    linkedtype: this.linkedtype ?? this.$store.getters.linkedtype,
                    linkedid: this.linkedid ?? this.$store.getters.linkedid,
                    emitEditSuccess: this.emitEditSuccess ?? null,
                },
            });
        },
    },
};
</script>
